import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css'],
})
export class PopupDialogComponent {
  errorState: string;

  constructor(
    public dialogRef: MatDialogRef<PopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    dialogRef.disableClose = true;
  }

  onSuccess(): void {
    this.data.state = 'done';
    this.dialogRef.close(this.data);
  }

  onErrorSuccess(): void {
    this.data.state = 'error';
    this.dialogRef.close(this.data);
  }

  onReviewRequest(): void {
    this.data.state = 'review';
    this.dialogRef.close(this.data);
  }

  onBack(): void {
    this.data.state = null;
    this.dialogRef.close(this.data);
  }
}

export interface DialogData {
  comment: string;
  state: string;
  error: string;
}
